import { useMemo } from "react"

function useInitialData(data, initData) {
  const defaultData = {
    count: 0,
    next: null,
    previous: null,
    results: [],
  }

  const memoData = useMemo(() => {
    if (data) return data
    if (initData) return initData
    return defaultData
  }, [data])

  return memoData
}

export default useInitialData
